import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './services/language-service/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'insight-client';

  constructor(translate: TranslateService, languageService: LanguageService) {
    try {
      console.log('🔄 AppComponent: Initializing...');
      
      var langs: string[] = [];
      const languages = languageService.GetLanguages();
      console.log('📋 AppComponent: Available languages:', languages);
      
      languages.forEach(element => {
        langs.push(element.value);
      });
      
      translate.addLangs(langs);
      const currentLang = languageService.GetCurrentLanguage();
      console.log('🌐 AppComponent: Using language:', currentLang);
      translate.use(currentLang);
      
      console.log('✅ AppComponent: Initialized successfully');
    } catch (error: any) {
      const errorMsg = `AppComponent init error: ${error?.message || error}\nStack: ${error?.stack || 'N/A'}`;
      console.error('❌', errorMsg);
      alert(errorMsg);
    }
  }
}
